interface AnnotationPopupButtonOptions {
  label: string;
  iconSrc: string;
  onClick: () => void;
}

export function createAnnotationPopupButton({ label, iconSrc, onClick }: AnnotationPopupButtonOptions) {
  const renderButton = () => {
    const container = document.createElement('div');
    container.style.display = 'flex';
    container.style.alignItems = 'center';
    container.style.cursor = 'pointer';
    container.style.padding = '8px';
    container.style.gap = '8px';
    container.style.userSelect = 'none';
    container.style.webkitUserSelect = 'none';
    container.draggable = false;
    container.setAttribute('role', 'button');
    container.tabIndex = 0;
    container.setAttribute('aria-label', label);

    const icon = document.createElement('img');
    icon.src = iconSrc;
    icon.alt = label;
    icon.style.width = '16px';
    icon.style.height = '16px';
    icon.draggable = false;
    container.appendChild(icon);

    const text = document.createElement('span');
    text.textContent = label;
    text.style.fontSize = '14px';
    text.style.color = 'white';
    text.style.whiteSpace = 'nowrap';
    text.style.userSelect = 'none';
    text.style.webkitUserSelect = 'none';
    text.draggable = false;
    container.appendChild(text);

    container.addEventListener('click', onClick);

    container.addEventListener('keydown', (e) => {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        onClick();
      }
    });

    container.addEventListener('dragstart', (e) => {
      e.preventDefault();
      return false;
    });

    container.addEventListener('selectstart', (e) => {
      e.preventDefault();
      return false;
    });

    return container;
  };

  return {
    type: 'customElement' as const,
    render: renderButton,
  };
}
